import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
  TypographyTypeMap as MuiTypographyTypeMap,
} from "@material-ui/core";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import classNames from "classnames";

import {
  generateClasses,
  OptionalBreakpointValues,
} from "../../utilities/functions";

type HeadingProps = {
  readonly spacingBottom?: number | OptionalBreakpointValues;
};

export const Heading: OverridableComponent<
  MuiTypographyTypeMap<HeadingProps, "span">
> = ({
  spacingBottom,
  className,
  ...restProps
}: HeadingProps & MuiTypographyProps) => {
  const additionalStyles = generateClasses({
    spacingBottom,
  });

  const classes = classNames(...additionalStyles, className);

  return <MuiTypography {...restProps} className={classes} />;
};
